import * as React from "react";
import Row from "../../layout/Row";
import Col from "../../layout/Col";
import {FormField} from "../../../validation/FormField";
import PartnerBrandBankDataForm from "../../partnerBrand/PartnerBrandBankDataForm";
import MaskedTextInputFormGroup from "../../ui/form/MaskedTextInputFormGroup";
import FormValidators from "../../../validation/FormValidators";
import InputFormGroup from "../../../hiberUiKit/src/molecules/FormGroup/InputFormGroup";
import FormHelper from "../../../helper/FormHelper";

interface ComponentProps {
	/**
	 * Form containing partner brand bank data inputs.
	 */
	form: PartnerBrandBankDataForm;
	/**
	 * On change fields.
	 * @param fields updated fields.
	 */
	onFieldsChange: (fields: FormField<any>[]) => void;
	/**
	 * On change field.
	 * @param fields updated fields.
	 */
	onFieldChange: (field: FormField<any>) => void;
}

export default class PartnerBrandBankDataFormBody extends React.PureComponent<ComponentProps, {}> {
	render() {
		const form = this.props.form;
		const accountHolderInputDisabled = FormHelper.isStringFormFieldEmpty(form.bankSortCode)
			&& FormHelper.isStringFormFieldEmpty(form.bankAccountNumber);
		return (
			<div className={"c-create-brand"}>
				<Row>
					<Col xl={4} md={4}>
						<MaskedTextInputFormGroup label="Bank sort code"
												  placeholder="Enter bank sort code"
												  field={form.bankSortCode}
												  onChange={this.onBankSortCodeChange}
												  mask={[/\d/, /\d/, '-', /\d/, /\d/, '-', /\d/, /\d/]}
												  getValue={this.removeNonDigits}/>
					</Col>
					<Col xl={4} md={4}>
						<MaskedTextInputFormGroup label="Bank account number"
												  placeholder="Enter bank account number"
												  field={form.bankAccountNumber}
												  onChange={this.onBankAccountNumberChange}
												  mask={[/\d/, /\d/, /\d/, /\d/, /\d/, /\d/, /\d/, /\d/]}
												  getValue={this.removeNonDigits}/>
					</Col>
					<Col xl={4} md={4}>
						<InputFormGroup label="Account Holder"
										placeholder="Enter Account Holder name"
										field={form.accountHolder}
										onChange={this.props.onFieldChange}
										disabled={accountHolderInputDisabled}/>
					</Col>
				</Row>
			</div>
		);
	}

	/**
	 * Get 123456 from 12-34-56 etc.
	 * @param {string} value
	 * @returns {string}
	 */
	removeNonDigits = (value: string) => {
		return value.replace(/\D+/g, '');
	};

	onBankSortCodeChange = (bankSortCodeField: FormField<string>) => {
		let bankAccountNumberField: FormField<string>;
		if (bankSortCodeField.getOptionalValue().map(v => !!v.length).getOrElse(false)) {
			bankAccountNumberField =
				this.props.form.bankAccountNumber.setRules([
					FormValidators.isAccountNoBankDataValid("Bank data is invalid", bankSortCodeField)
				]);
		}
		else {
			bankAccountNumberField = this.props.form.bankAccountNumber.setRules([]);
		}
		this.props.onFieldsChange([bankSortCodeField, bankAccountNumberField]);
	};

	onBankAccountNumberChange = (bankAccountNumberField: FormField<string>) => {
		let bankSortCodeField: FormField<string>;
		if (bankAccountNumberField.getOptionalValue().map(v => !!v.length).getOrElse(false)) {
			bankSortCodeField =
				this.props.form.bankSortCode.setRules([
					FormValidators.isSortCodeBankDataValid("Bank data is invalid", bankAccountNumberField)
				]);
		}
		else {
			bankSortCodeField = this.props.form.bankSortCode.setRules([]);
		}
		this.props.onFieldsChange([bankAccountNumberField, bankSortCodeField]);
	};
}
